export default __webpack_public_path__ + "static/media/gu.9ef9a109.svg";